import React, { PureComponent } from 'react';

import BookingLargeComponent from './booking-large-component';


class BookingListComponent extends PureComponent {
  constructor(props) {
    super(props);
  }


  render() {
    let { bookings, isOwner } = this.props;

    if (!bookings) return (<div className="container text-center"><h4>Loading...</h4></div>)

    return (<div className="container booking-list-container p-0">
      {bookings.map((b) => {
        return <BookingLargeComponent key={b._id} booking={b} isOwner={isOwner} />
      })}
    </div>);

  }
}

export default BookingListComponent;
